import { render, staticRenderFns } from "./strategic.vue?vue&type=template&id=0bae06ad&"
import script from "./strategic.vue?vue&type=script&lang=js&"
export * from "./strategic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports